import { AxiosRequestConfig } from 'axios';

import { KlassItem } from '../shared';
import { BASE_API } from '../utils';

export interface KlassAssignmentsIndexByExercisesItem {
  assignedAt: string | null;
  class: KlassItem;
  classId: string;
  className: string;
  defaultAssignmentName: string | null;
  hasSpiralReviewSkills: boolean;
  releaseDate: string | null;
}

interface ListForAssignmentConfig extends AxiosRequestConfig {
  method: 'GET';
  url: `/teachers/${string}/assignable-classes`;
  params: { 'assignment-id': number };
}

export type KlassAssignmentsIndexByExercisesResponse =
  KlassAssignmentsIndexByExercisesItem[];

/**
 * GET /vo/v1/teachers/${teacherId}/assignable-classes?assignment-id=${assignmentId}
 */
export const listForAssignment = (
  teacherId: string,
  assignmentId: number,
): ListForAssignmentConfig => {
  return {
    baseURL: BASE_API,
    method: 'GET',
    url: `/teachers/${teacherId}/assignable-classes`,
    params: { 'assignment-id': assignmentId },
  } as const;
};
